import { v4 as uuidV4 } from 'uuid';

const initialState = {
  examsAdded: [],
  uploadExams: {
    id: '',
    exams: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case '@exams/SET_EXAMS_ADDED':
      return {
        ...state,
        examsAdded: action.examsAdded,
      };

    case '@exams/SET_UPLOAD_EXAMS':
      return {
        ...state,
        uploadExams: {
          id: uuidV4(),
          exams: action.uploadExams,
        },
      };

    default:
      return state;
  }
};

export default reducer;
